import { render, staticRenderFns } from "./SettlementAdvances.vue?vue&type=template&id=13fca4e7&"
import script from "./SettlementAdvances.vue?vue&type=script&lang=js&"
export * from "./SettlementAdvances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports